import { render, staticRenderFns } from "./vastuuhenkilon-arvio-vastuuhenkilo.vue?vue&type=template&id=68691386&"
import script from "./vastuuhenkilon-arvio-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./vastuuhenkilon-arvio-vastuuhenkilo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports